
const SETTINGS = {
    LOCAL_PRODUCTION: false, // flag to force PRODUCTION on local
};

/* eslint-disable-next-line no-undef */
if (__PRODUCTION__ || (!__STAGING__ && SETTINGS.LOCAL_PRODUCTION)) {

    SETTINGS.PRODUCTION = true;
    SETTINGS.API_SERVER_ADDRESS = 'https://api.sifiveacademy.com/';
    SETTINGS.API_KEY = '8qohKR5Qmt31LBA8qQS3y3PCp1EE153T3VLGHdXH';
    SETTINGS.GOOGLE_CLIENTID = '250262930239-r728buribfko3b16uqvpsrb38jgtng77.apps.googleusercontent.com';
    SETTINGS.FACEBOOK_APPID = '446641592846874';

} else if (__STAGING__) {// eslint-disable-line no-undef

    SETTINGS.STAGING = true;
    SETTINGS.API_SERVER_ADDRESS = 'https://staging-api.sifiveacademy.com/';
    SETTINGS.API_KEY = 'WSQ2vyiBOr7IoqP5uUM2V9BWiqkPack82QLhT1Zq';
    SETTINGS.GOOGLE_CLIENTID = '250262930239-r728buribfko3b16uqvpsrb38jgtng77.apps.googleusercontent.com';
    SETTINGS.FACEBOOK_APPID = '446641592846874';

} else {

    SETTINGS.LOCAL = true;
    SETTINGS.API_SERVER_ADDRESS = 'https://staging-api.sifiveacademy.com/';
    SETTINGS.API_KEY = 'WSQ2vyiBOr7IoqP5uUM2V9BWiqkPack82QLhT1Zq';
    SETTINGS.GOOGLE_CLIENTID = '250262930239-r728buribfko3b16uqvpsrb38jgtng77.apps.googleusercontent.com';
    SETTINGS.FACEBOOK_APPID = '446641592846874';

}

export default SETTINGS;
export const API_SERVER_ADDRESS = SETTINGS.API_SERVER_ADDRESS;
export const API_KEY = SETTINGS.API_KEY;
export const GOOGLE_CLIENTID = SETTINGS.GOOGLE_CLIENTID;
export const FACEBOOK_APPID = SETTINGS.FACEBOOK_APPID;
